import React, { useContext } from 'react';
import { Handle, Position } from '@xyflow/react';
import { AccountBalanceOutlined } from '@mui/icons-material';
import { OrgSettingsContext } from '../../../../../contexts/org-settings-context';
import { grey } from '@mui/material/colors';
import CashFlowSummary from '../active-cash-pie-chart';

export const AccountingDepartmentNode = ({ data }: any) => {
  const { color } = useContext(OrgSettingsContext);
  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: '1px solid #e0e0e0',
        borderRadius: '16px',
        padding: '20px',
        width: 260,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
        fontFamily: `'Inter', 'Helvetica Neue', sans-serif`,
        color: '#333',
        position: 'relative',
      }}
    >
      {/* Icon and Title */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <div
          style={{
            background: grey[100],
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
          }}
        >
          <AccountBalanceOutlined style={{ fontSize: 22, color: color }} />
        </div>
        <div style={{ fontSize: '1rem', fontWeight: 600 }}>
          Accounting Dept.
        </div>
      </div>
        
      
      <CashFlowSummary data={data.cashFlowData} />

      {/* Handles */}
      <Handle
        type="target"
        position={Position.Right}
        id="right-sink"
        style={{
          opacity: 0,
          width: 5,
          height: 5,
          borderRadius: '50%',
          border: '2px solid white',
          right: -5,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />

      <Handle
        type="source"
        position={Position.Left}
        id="left-source"
        style={{
          opacity: 0,
          width: 5,
          height: 5,
          borderRadius: '50%',
          border: '2px solid white',
          left: -5,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />

      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom-source"
        style={{
          opacity: 0,
          width: 0,
          height: 0,
          borderRadius: '50%',
          border: '2px solid white',
          bottom: -5,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      />
    </div>
  );
};
